import { SET_FILTER, SET_FILTER_PERSON, SET_FILTER_TEAM } from '../constants/index';
import { MyWalkFilterState, MyWalkFilterActions } from '../types/myWalkFilterTypes'

const initialState: MyWalkFilterState = {
  filter: null,
  person: 0,
  team: 0
}

const myWalkFilterReducer = (state = initialState, action: MyWalkFilterActions) => {
  const payload = action.payload
  switch(action.type){

    case SET_FILTER:
      return {
        ...state,
        filter: payload
      }
    
    case SET_FILTER_PERSON:
      return {
        ...state,
        person: payload
      }

    case SET_FILTER_TEAM:
      return {
        ...state,
        team: payload
      }

    default: 
      return state
  }
}

export default myWalkFilterReducer;